import {connect} from 'react-redux';
import React from 'react';
import {Link} from 'react-router';
import { MetricsElement } from "react-metrics";
import { trackClick } from 'utils/AnalyticsUtils';

export function HorseRacingInsightsList({insights, keyedInsightNames}) {
    const insightsUrl = "/racing/insights";
    const insightsLinkClickEventName = "insightsLinkClick";
    if (!insights || insights.length === 0) {
        return [];
    }

    function renderInsight(insight, idx) {
        if (!insight.type) {
            return null;
        }

        const insightTrackingAttrs = trackClick(insightsLinkClickEventName, {link: `[Insights] Racecard ${insight.type} Link`});

        return (
            <li key={insight.type}>
                <Link {...insightTrackingAttrs} to={`${insightsUrl}#${insight.type.toLowerCase()}`}>{idx > 0 ? ', ' : ''}{keyedInsightNames.get(insight.type)}</Link>
            </li>
        )
    }

    const insightsTrackingAttrs = trackClick(insightsLinkClickEventName, {link: "[Insights] Racecard Link"});

    return (
        <MetricsElement>
            <div className="hr-insight-list">
                <h4><Link {...insightsTrackingAttrs} to={insightsUrl}><span className="new-flag bold">Insights</span></Link></h4>
                <ul>
                    {insights.map(renderInsight)}
                </ul>                    
            </div>
        </MetricsElement> 
    );
}

const mapStateToProps = state => {
    let keyedInsightNames = new Map();

    const insights = state.horseRacing.insights;
    if (insights && insights.length > 0) {
        keyedInsightNames = insights.reduce((insightMap, insight) => {
            return insightMap.set(insight.type, insight.title);
        }, new Map());
    }

    return {
        keyedInsightNames 
    }
}

export default connect(mapStateToProps)(HorseRacingInsightsList);


// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingInsightsList.js